import adminDashboardUrl from '@providers/adminDashboardUrl'

export default function getAdminDashboardUrl(websiteId: string, subpath: string = ''): string {
  const adminUrl = adminDashboardUrl
  return `${adminUrl}/admin${subpath}?websiteId=${websiteId}`
}
